import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { COLOR, FONT } from '../../../constants/styles';
import OPComponent from '../op_component';

export default class ErrorView extends OPComponent {
  render() {
    const { errorText } = this.props;

    return (
      <View style={[styles.container, this.props.style]}>
        <Text style={styles.errorMessage}>{this.props.errorText}</Text>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#FEF2F2',
    paddingVertical: 25,
    paddingHorizontal: 30,
    borderWidth: 1,
    borderColor: '#F05050',
  },
  errorMessage: {
    ...FONT.semibold,
    fontSize: 16,
    color: '#B10F0F',
  },
});
